import React from 'react';
import { R0006_ACCESS_CONTROLLED_HEADER_CONFIG } from '../config/headerControls';

/**
 * Creates header controls for R0006 report based on configuration
 * This is a pure function that doesn't use React hooks
 */
export const createR0006HeaderControls = ({
  dateRange,
  selectedArea,
  dataReady,
  pageLoading,
  onDateRangeSubmit,
  onAreaChange,
  onExport,
  onCalendarClick, // New prop for calendar button click
  reportData,
  hasFullAccess,
  filteredAreas // Add filtered areas
}) => {
  // Current state for showWhen conditions
  const currentState = {
    dateRange,
    selectedArea,
    dataReady,
    pageLoading,
    reportData,
    hasFullAccess
  };

  // Create control handlers
  const controlHandlers = {
    'area-selector': {
      value: selectedArea,
      onChange: onAreaChange,
      disabled: pageLoading,
      filteredAreas: filteredAreas,
      hasFullAccess: hasFullAccess
    },
    'export-button': {
      onClick: onExport,
      disabled: !reportData
    },
    'calendar-button': {
      onClick: onCalendarClick,
      disabled: pageLoading
    }
  };

  // Helper function to create controls from config
  const createControlsFromConfig = (controlsConfig) => {
    return controlsConfig
      .filter(control => control.showWhen(currentState))
      .sort((a, b) => a.order - b.order)
      .map(control => {
        const Component = control.component;
        const handlers = controlHandlers[control.id] || {};
        
        return (
          <Component
            key={control.id}
            {...control.props}
            {...handlers}
          />
        );
      });
  };

  // Generate controls from configuration
  const leftControls = createControlsFromConfig(R0006_ACCESS_CONTROLLED_HEADER_CONFIG.leftControls);
  const centerControls = createControlsFromConfig(R0006_ACCESS_CONTROLLED_HEADER_CONFIG.centerControls);
  const rightControls = createControlsFromConfig(R0006_ACCESS_CONTROLLED_HEADER_CONFIG.rightControls);

  return {
    leftControls,
    centerControls,
    rightControls
  };
};